import React, { useState, useEffect } from 'react';
import API from '../api/api';
import Slots from './Slots';
import UserManagement from './UserManagement';

const COLORS_LIST = ['#abcaf2','#ffead1','#e8b65e','#bff4a9','#15aaf4','#fdffa3','#d29104','#f4f5d6','#76ae6b','#f4c2c2','#c2f4e8','#e8c2f4','#ffffff','#dddddd'];

function TagInput({ value, onChange, placeholder }) {
  const [input, setInput] = useState('');
  const tags = value ? value.split(',').map(t => t.trim()).filter(Boolean) : [];
  const add = () => { if (input.trim()) { onChange([...tags, input.trim()].join(',')); setInput(''); }};
  const remove = (i) => onChange(tags.filter((_,j) => j !== i).join(','));
  return (
    <div style={{border:'1px solid #ddd',borderRadius:'6px',padding:'6px',minHeight:'40px',display:'flex',flexWrap:'wrap',gap:'4px',background:'white'}}>
      {tags.map((t,i) => (
        <span key={i} style={{background:'#e8f4fd',padding:'2px 8px',borderRadius:'12px',fontSize:'12px',display:'flex',alignItems:'center',gap:'4px'}}>
          {t}<button onClick={()=>remove(i)} style={{background:'none',border:'none',cursor:'pointer',color:'#e74c3c',fontWeight:'bold',padding:'0',fontSize:'12px'}}>x</button>
        </span>
      ))}
      <input value={input} onChange={e=>setInput(e.target.value)} onKeyDown={e=>{if(e.key==='Enter'){e.preventDefault();add();}}}
        placeholder={placeholder} style={{border:'none',outline:'none',fontSize:'12px',minWidth:'120px',flex:1}}/>
      <button onClick={add} style={{background:'#3498db',color:'white',border:'none',borderRadius:'4px',padding:'2px 8px',cursor:'pointer',fontSize:'11px'}}>اضافة</button>
    </div>
  );
}

function ControlPanel({ partnership, onRefresh, onDelete }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [section, setSection] = useState('info');
  const [info, setInfo] = useState({});
  const [msgTemplateType, setMsgTemplateType] = useState('');
  const [previewMsg, setPreviewMsg] = useState('');
  const [partners, setPartners] = useState([]);
  const [feePeriods, setFeePeriods] = useState([]);
  const [newPartner, setNewPartner] = useState('');
  const [newFee, setNewFee] = useState({from_date:'',meter_fee:'',worker_fee:''});
  const [editFeeId, setEditFeeId] = useState(null);
  const [editFeeData, setEditFeeData] = useState({from_date:'',meter_fee:'',worker_fee:''});
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [msg, setMsg] = useState('');
  const [licenses, setLicenses] = useState([]);
  const [licLoading, setLicLoading] = useState(false);
  const [licForm, setLicForm] = useState({ device_id:'', owner_name:'', expires_at:'', notes:'' });
  const [licMsg, setLicMsg] = useState('');
  const [apiRate, setApiRate] = useState('');
  const [apiRateMsg, setApiRateMsg] = useState('');

  useEffect(() => { load(); }, [partnership.id]);
  useEffect(() => { if (section === 'licenses') fetchLicenses(); }, [section]);
  useEffect(() => {
    if (section === 'whatsapp') {
      API.get('/whatsapp-api-rate/').then(res => setApiRate(String(res.data.whatsapp_api_rate))).catch(()=>{});
    }
  }, [section]);
  const saveApiRate = async () => {
    try {
      await API.post('/whatsapp-api-rate/', { whatsapp_api_rate: apiRate });
      setApiRateMsg('✅ تم الحفظ بنجاح');
    } catch (e) {
      setApiRateMsg('❌ فشل الحفظ');
    }
    setTimeout(() => setApiRateMsg(''), 3000);
  };

  const fetchLicenses = async () => {
    setLicLoading(true);
    try { const res = await API.get('/license/list/'); setLicenses(res.data || []); }
    catch(e) { setLicenses([]); }
    setLicLoading(false);
  };
  const addLicense = async () => {
    if (!licForm.device_id.trim() || !licForm.owner_name.trim()) { setLicMsg('يرجى إدخال رقم الجهاز والاسم'); return; }
    try {
      await API.post('/license/list/', licForm);
      setLicMsg('✅ تم إضافة الترخيص بنجاح');
      setLicForm({ device_id:'', owner_name:'', expires_at:'', notes:'' });
      fetchLicenses();
    } catch(e) { setLicMsg('❌ خطأ — تأكد أن رقم الجهاز غير مكرر'); }
    setTimeout(() => setLicMsg(''), 4000);
  };
  const toggleLicense = async (id, currentState) => {
    try { await API.patch('/license/list/'+id+'/', { is_active: !currentState }); fetchLicenses(); }
    catch(e) { alert('خطأ في تحديث الترخيص'); }
  };

  const load = async () => {
    setLoading(true);
    const res = await API.get(`/settings/${partnership.id}/`);
    setData(res.data);
    setInfo(res.data.settings);
    setPartners(res.data.partners);
    setFeePeriods(res.data.fee_periods);
    setLoading(false);
  };

  const save = async (action, payload) => {
    setSaving(true);
    try {
      await API.post(`/settings/${partnership.id}/`, { action, ...payload });
      setMsg('تم الحفظ بنجاح');
      setTimeout(() => setMsg(''), 3000);
      await load();
      if (onRefresh) onRefresh();
    } catch(e) { setMsg('خطا في الحفظ'); }
    setSaving(false);
  };

  const sectionBtn = (key, label, icon) => (
    <button onClick={() => setSection(key)} style={{padding:'8px 14px',background:section===key?'#1e3a5f':'white',color:section===key?'white':'#1e3a5f',border:'1px solid #1e3a5f',borderRadius:'6px',cursor:'pointer',fontSize:'12px',fontWeight:section===key?'bold':'normal'}}>
      {icon} {label}
    </button>
  );

  if (loading) return <div style={{textAlign:'center',padding:'40px',color:'#666'}}>جاري التحميل...</div>;

  return (
    <div style={{padding:'15px'}} dir="rtl">
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'15px',flexWrap:'wrap',gap:'8px'}}>
        <h3 style={{margin:0,color:'#1e3a5f'}}>لوحة التحكم - {partnership.name}</h3>
        {msg && <span style={{padding:'6px 12px',background:msg.includes('نجاح')?'#d4edda':'#f8d7da',borderRadius:'6px',fontSize:'13px'}}>{msg}</span>}
      </div>
      <div style={{display:'flex',gap:'8px',overflowX:'auto',WebkitOverflowScrolling:'touch',marginBottom:'15px',paddingBottom:'5px',scrollbarWidth:'thin',scrollbarColor:'#1e3a5f #f0f0f0'}}>
        {(()=>{
          const u=JSON.parse(localStorage.getItem('user')||'null');
          const isAdmin=!u||u.role==='admin';
          const perms=u?(u.permissions||[]):[];
          const show=(perm)=>isAdmin||perms.includes(perm);
          return <>
            {show('cp_info')&&sectionBtn('info','معلومات البئر','🏗️')}
            {show('cp_partners')&&sectionBtn('partners','الشركاء','👥')}
            {show('cp_cycles')&&sectionBtn('cycles','الدورات','🔄')}
            {show('cp_sessions')&&sectionBtn('sessions','جلسات التشغيل','⚡')}
            {show('cp_fees')&&sectionBtn('fees','رسوم العداد والعامل','⚡')}
            {show('cp_whatsapp')&&sectionBtn('whatsapp','اعدادات الواتساب','💬')}
            {show('cp_lists')&&sectionBtn('lists','قوائم المصروفات','📋')}
            {show('cp_slots')&&sectionBtn('slots','الخانات والاصدارات','📦')}
            {show('cp_security')&&sectionBtn('security','الامان','🔒')}
            {(isAdmin||perms.includes('cp_users'))&&sectionBtn('users','المستخدمين','👤')}
            {isAdmin&&sectionBtn('danger','حذف الشراكة','🗑️')}
            {show('cp_backup')&&sectionBtn('backup','نسخة احتياطية','💾')}
            {isAdmin&&sectionBtn('licenses','تراخيص WellManager','🔑')}
          </>;
        })()}
      </div>

      {section === 'cycles' && (
        <div style={{background:'white',padding:'20px',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
          <h4 style={{margin:'0 0 15px',color:'#1e3a5f',borderBottom:'2px solid #eee',paddingBottom:'8px'}}>🔄 الدورات</h4>
          {data?.cycles?.length > 0 && data.cycles.map(cycle => (
            <div key={cycle.id} style={{background:'#f8f9fa',padding:'15px',borderRadius:'8px',marginBottom:'12px',border:'1px solid #ddd'}}>
              <div style={{display:'flex',alignItems:'center',gap:'12px',flexWrap:'wrap'}}>
                <span style={{fontWeight:'bold',color:'#1e3a5f',fontSize:'14px'}}>دورة {cycle.number}</span>
                <span style={{fontSize:'12px',color:'#666'}}>تاريخ البداية:</span>
                <input type="date" defaultValue={cycle.start_date||''}
                  id={`cycle-date-${cycle.id}`}
                  style={{padding:'6px',border:'1px solid #ddd',borderRadius:'5px',fontSize:'13px'}}/>
                <button onClick={async()=>{
                  const val = document.getElementById(`cycle-date-${cycle.id}`).value;
                  if(!val){alert('يرجى اختيار تاريخ');return;}
                  try{
                    await save('update_cycle_date',{cycle_id:cycle.id, start_date:val});
                    setMsg('تم تعديل تاريخ بداية الدورة');
                  }catch(e){alert('خطأ في الحفظ');}
                }} style={{padding:'6px 14px',background:'#27ae60',color:'white',border:'none',borderRadius:'5px',cursor:'pointer',fontSize:'12px',fontWeight:'bold'}}>
                  حفظ
                </button>
              </div>
              {/* أيام التشغيل */}
              <div style={{marginTop:'12px',borderTop:'1px solid #eee',paddingTop:'12px'}}>
                <div style={{fontSize:'12px',fontWeight:'bold',color:'#1e3a5f',marginBottom:'8px'}}>📅 أيام التشغيل:</div>
                <div style={{display:'flex',flexWrap:'wrap',gap:'8px',marginBottom:'10px'}}>
                  {[{id:0,label:'الأحد'},{id:1,label:'الاثنين'},{id:2,label:'الثلاثاء'},{id:3,label:'الأربعاء'},{id:4,label:'الخميس'},{id:5,label:'الجمعة'},{id:6,label:'السبت'}].map(day=>(
                    <label key={day.id} style={{display:'flex',alignItems:'center',gap:'4px',cursor:'pointer',
                      padding:'5px 10px',borderRadius:'20px',fontSize:'12px',fontWeight:'bold',
                      background:(cycle.working_days||[]).includes(day.id)?'#1e3a5f':'#f0f0f0',
                      color:(cycle.working_days||[]).includes(day.id)?'white':'#333',
                      border:'1px solid '+((cycle.working_days||[]).includes(day.id)?'#1e3a5f':'#ddd')}}>
                      <input type="checkbox"
                        checked={(cycle.working_days||[]).includes(day.id)}
                        onChange={async(e)=>{
                          const current = cycle.working_days||[];
                          const updated = e.target.checked ? [...current,day.id] : current.filter(d=>d!==day.id);
                          try{
                            await API.patch(`/cycles/${cycle.id}/`,{working_days:updated});
                            cycle.working_days = updated;
                            setMsg('تم حفظ أيام التشغيل');
                            setTimeout(()=>setMsg(''),2000);
                          }catch(err){alert('خطأ في الحفظ');}
                        }}
                        style={{display:'none'}}/>
                      {day.label}
                    </label>
                  ))}
                </div>
                <div style={{fontSize:'11px',color:'#888'}}>
                  {(cycle.working_days||[]).length === 0 ? '⚠️ لم يتم تحديد أيام التشغيل (ستعمل جميع الأيام)' : `✅ ${(cycle.working_days||[]).length} أيام تشغيل محددة`}
                </div>
              </div>
            </div>
          ))}
          <button onClick={()=>window.dispatchEvent(new CustomEvent('switchTab',{detail:'cycles'}))}
            style={{padding:'10px 20px',background:'#1e3a5f',color:'white',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'13px',fontWeight:'bold',marginTop:'10px'}}>
            🔄 فتح تبويب الدورات
          </button>
        </div>
      )}
      {section === 'sessions' && (
        <div style={{background:'white',padding:'20px',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
          <h4 style={{margin:'0 0 15px',color:'#1e3a5f',borderBottom:'2px solid #eee',paddingBottom:'8px'}}>⚡ جلسات التشغيل</h4>
          <p style={{color:'#666',fontSize:'13px',marginBottom:'15px'}}>إدارة جلسات التشغيل من هنا</p>
          <button onClick={()=>window.dispatchEvent(new CustomEvent('switchTab',{detail:'sessions'}))}
            style={{padding:'10px 20px',background:'#1e3a5f',color:'white',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'13px',fontWeight:'bold'}}>
            ⚡ فتح تبويب جلسات التشغيل
          </button>
        </div>
      )}
      {section === 'info' && (
        <div style={{background:'white',padding:'20px',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
          <h4 style={{margin:'0 0 15px',color:'#1e3a5f',borderBottom:'2px solid #eee',paddingBottom:'8px'}}>معلومات البئر</h4>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'15px',marginBottom:'15px'}}>
            <div><label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'5px'}}>اسم البئر</label>
              <input value={info.name||data?.partnership?.name||''} onChange={e=>setInfo({...info,name:e.target.value})} style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',boxSizing:'border-box'}}/></div>
            <div><label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'5px'}}>تاريخ بدء التشغيل</label>
              <input type="date" value={info.start_date||data?.partnership?.start_date||''} onChange={e=>setInfo({...info,start_date:e.target.value})} style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',boxSizing:'border-box'}}/></div>
          </div>
          <div style={{marginBottom:'15px'}}>
            <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'5px'}}>وصف مختصر</label>
            <input value={info.description||''} onChange={e=>setInfo({...info,description:e.target.value})}
              placeholder="مثال: دورة 9 ايام - 9 شركاء"
              style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',boxSizing:'border-box'}}/>
          </div>
          <div style={{marginBottom:'15px'}}>
            <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'5px'}}>الموقع</label>
            <input value={info.location||data?.partnership?.location||''} onChange={e=>setInfo({...info,location:e.target.value})}
              placeholder="مثال: حوطة بني تميم - الفرعة"
              style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',boxSizing:'border-box'}}/>
          </div>
          <button onClick={()=>save('save_info',info)} disabled={saving}
            style={{padding:'9px 20px',background:'#27ae60',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>
            حفظ المعلومات
          </button>
        </div>
      )}

      {section === 'partners' && (
        <div style={{background:'white',padding:'20px',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
          <h4 style={{margin:'0 0 10px',color:'#1e3a5f',borderBottom:'2px solid #eee',paddingBottom:'8px'}}>ادارة الشركاء والوان الصفوف وارقام الواتساب</h4>
          <p style={{fontSize:'11px',color:'#888',margin:'0 0 12px',background:'#f0f4f8',padding:'8px',borderRadius:'6px'}}>
            لون كل شريك يظهر في جدول التشغيل وجميع التقارير. رقم الواتساب للارسال المباشر (مثال: 966501234567)
          </p>
          {partners.map((p, i) => (
            <div key={p.id} style={{display:'flex',alignItems:'center',gap:'8px',marginBottom:'10px',padding:'10px',background:'#f8f9fa',borderRadius:'8px',borderRight:`4px solid ${p.color}`}}>
              <span style={{fontSize:'13px',fontWeight:'bold',color:'#1e3a5f',minWidth:'20px'}}>{p.order}</span>
              <span style={{fontSize:'12px',flex:1,fontWeight:'bold'}}>{p.name}</span>
              <input type="tel" value={p.phone} onChange={e=>{const np=[...partners];np[i]={...np[i],phone:e.target.value};setPartners(np);}}
                placeholder="966501234567" style={{padding:'6px',border:'1px solid #ddd',borderRadius:'5px',fontSize:'12px',width:'130px'}}/>
              <input type="text" value={p.extra_phones||''} onChange={e=>{const np=[...partners];np[i]={...np[i],extra_phones:e.target.value};setPartners(np);}}
                placeholder="أرقام الإخوة: 966501111111,966502222222" title="أرقام إخوة الشريك (مفصولة بفاصلة)" style={{padding:'6px',border:'1px solid #ddd',borderRadius:'5px',fontSize:'12px',width:'220px'}}/>
              <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                  <input type="color" value={p.color||'#3498db'}
                    onChange={e=>{const np=[...partners];np[i]={...np[i],color:e.target.value};setPartners(np);}}
                    style={{width:'36px',height:'36px',padding:'2px',border:'1px solid #ddd',borderRadius:'5px',cursor:'pointer'}}/>
                  <span style={{fontSize:'11px',color:'#666'}}>{p.color||'#3498db'}</span>
                </div>
              <button onClick={()=>save('save_partner',{partner_id:p.id,phone:partners[i].phone,extra_phones:partners[i].extra_phones,color:partners[i].color})}
                style={{padding:'5px 10px',background:'#27ae60',color:'white',border:'none',borderRadius:'5px',cursor:'pointer',fontSize:'11px',whiteSpace:'nowrap'}}>حفظ</button>
              <button onClick={()=>{
                const val = window.prompt('اكتب اسم الشريك للتأكيد:\n' + p.name);
                if(val === null) return;
                if(val.trim() !== p.name.trim()){alert('الاسم غير صحيح!');return;}
                save('delete_partner',{partner_id:p.id});
              }} style={{padding:'5px 8px',background:'#e74c3c',color:'white',border:'none',borderRadius:'5px',cursor:'pointer',fontSize:'11px'}}>حذف</button>
            </div>
          ))}
          <div style={{display:'flex',gap:'8px',marginTop:'15px',padding:'12px',background:'#e8f5e9',borderRadius:'8px'}}>
            <input value={newPartner} onChange={e=>setNewPartner(e.target.value)} placeholder="الاسم الرباعي الكامل للشريك الجديد"
              style={{flex:1,padding:'8px',border:'1px solid #ddd',borderRadius:'5px',fontSize:'13px'}}/>
            <button onClick={()=>{if(newPartner.trim()){save('add_partner',{name:newPartner});setNewPartner('');}}}
              style={{padding:'8px 16px',background:'#1e3a5f',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>+ اضافة شريك</button>
          </div>
        </div>
      )}

      {section === 'fees' && (
        <div style={{background:'white',padding:'20px',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
          <h4 style={{margin:'0 0 10px',color:'#1e3a5f',borderBottom:'2px solid #eee',paddingBottom:'8px'}}>رسوم العداد والعامل (تاريخية)</h4>
          <p style={{fontSize:'11px',color:'#888',margin:'0 0 15px',background:'#fff3cd',padding:'8px',borderRadius:'6px'}}>
            كل فاتورة تستخدم الرسوم السارية في تاريخها تلقائيا - الماضي لا يتاثر
          </p>
          <table style={{width:'100%',borderCollapse:'collapse',marginBottom:'15px'}}>
            <thead style={{position:'sticky',top:0,zIndex:10}}><tr style={{background:'#1e3a5f',color:'white'}}>
              {['من تاريخ','رسوم العداد (ريال)','رسوم العامل (ريال)',''].map(h=>
                <th key={h} style={{padding:'9px 10px',fontSize:'12px',textAlign:'right'}}>{h}</th>)}
            </tr></thead>
            <tbody>
              {feePeriods.map((f,i)=>(
                editFeeId===f.id ? (
                <tr key={f.id} style={{background:'#fff9e6',borderBottom:'1px solid #eee'}}>
                  <td style={{padding:'6px 10px'}}>
                    <input type="date" value={editFeeData.from_date} onChange={e=>setEditFeeData({...editFeeData,from_date:e.target.value})} style={{padding:'5px',border:'1px solid #ddd',borderRadius:'4px',fontSize:'12px',width:'130px'}}/>
                  </td>
                  <td style={{padding:'6px 10px'}}>
                    <input type="number" step="0.01" value={editFeeData.meter_fee} onChange={e=>setEditFeeData({...editFeeData,meter_fee:e.target.value})} style={{padding:'5px',border:'1px solid #ddd',borderRadius:'4px',fontSize:'12px',width:'90px'}}/>
                  </td>
                  <td style={{padding:'6px 10px'}}>
                    <input type="number" step="0.01" value={editFeeData.worker_fee} onChange={e=>setEditFeeData({...editFeeData,worker_fee:e.target.value})} style={{padding:'5px',border:'1px solid #ddd',borderRadius:'4px',fontSize:'12px',width:'90px'}}/>
                  </td>
                  <td style={{padding:'9px 10px',display:'flex',gap:'5px'}}>
                    <button onClick={()=>{save('edit_fee_period',{id:f.id,...editFeeData});setEditFeeId(null);}} style={{padding:'4px 8px',background:'#27ae60',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'11px'}}>حفظ</button>
                    <button onClick={()=>setEditFeeId(null)} style={{padding:'4px 8px',background:'#95a5a6',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'11px'}}>إلغاء</button>
                  </td>
                </tr>
                ) : (
                <tr key={f.id} style={{background:i%2===0?'white':'#fafafa',borderBottom:'1px solid #eee'}}>
                  <td style={{padding:'9px 10px',fontSize:'13px',fontWeight:'bold',color:'#1e3a5f'}}>{f.from_date}</td>
                  <td style={{padding:'9px 10px',fontSize:'13px'}}>{f.meter_fee} ريال</td>
                  <td style={{padding:'9px 10px',fontSize:'13px'}}>{f.worker_fee} ريال</td>
                  <td style={{padding:'9px 10px',display:'flex',gap:'5px'}}>
                    <button onClick={()=>{setEditFeeId(f.id);setEditFeeData({from_date:f.from_date,meter_fee:f.meter_fee,worker_fee:f.worker_fee});}} style={{padding:'4px 8px',background:'#f39c12',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'11px'}}>تعديل</button>
                    {i>0&&<button onClick={()=>save('delete_fee_period',{id:f.id})} style={{padding:'4px 8px',background:'#e74c3c',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'11px'}}>حذف</button>}
                  </td>
                </tr>
                )
              ))}
            </tbody>
          </table>
          <div style={{background:'#e8f5e9',padding:'12px',borderRadius:'8px'}}>
            <h5 style={{margin:'0 0 10px',color:'#1e3a5f',fontSize:'13px'}}>اضافة فترة جديدة</h5>
            <div style={{display:'flex',gap:'10px',alignItems:'flex-end',flexWrap:'wrap'}}>
              <div><label style={{display:'block',fontSize:'11px',fontWeight:'bold',marginBottom:'4px'}}>من تاريخ</label>
                <input type="date" value={newFee.from_date} onChange={e=>setNewFee({...newFee,from_date:e.target.value})} style={{padding:'7px',border:'1px solid #ddd',borderRadius:'5px',fontSize:'13px'}}/></div>
              <div><label style={{display:'block',fontSize:'11px',fontWeight:'bold',marginBottom:'4px'}}>رسوم العداد</label>
                <input type="number" step="0.01" value={newFee.meter_fee} onChange={e=>setNewFee({...newFee,meter_fee:e.target.value})} style={{padding:'7px',border:'1px solid #ddd',borderRadius:'5px',fontSize:'13px',width:'110px'}}/></div>
              <div><label style={{display:'block',fontSize:'11px',fontWeight:'bold',marginBottom:'4px'}}>رسوم العامل</label>
                <input type="number" step="0.01" value={newFee.worker_fee} onChange={e=>setNewFee({...newFee,worker_fee:e.target.value})} style={{padding:'7px',border:'1px solid #ddd',borderRadius:'5px',fontSize:'13px',width:'110px'}}/></div>
              <button onClick={()=>{if(newFee.from_date){save('add_fee_period',newFee);setNewFee({from_date:'',meter_fee:'',worker_fee:''});}}}
                style={{padding:'8px 16px',background:'#1e3a5f',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>اضافة</button>
            </div>
          </div>
        </div>
      )}

      {section === 'whatsapp' && (
        <div style={{background:'white',padding:'20px',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
          <h4 style={{margin:'0 0 15px',color:'#1e3a5f',borderBottom:'2px solid #eee',paddingBottom:'8px'}}>اعدادات رسالة الواتساب</h4>
          {(() => {
            const u = JSON.parse(localStorage.getItem('user')||'null');
            const isAdmin = !u || u.role === 'admin';
            if (!isAdmin) return null;
            return (
              <div style={{marginBottom:'20px',background:'#fff9e6',border:'1px solid #f0d060',borderRadius:'8px',padding:'14px'}}>
                <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'6px',color:'#7a6000'}}>💰 سعر رسالة واتساب API (ريال) — إعداد عام لكل الشراكات</label>
                <div style={{display:'flex',gap:'10px',alignItems:'center',flexWrap:'wrap'}}>
                  <input type="number" step="0.01" value={apiRate} onChange={e=>setApiRate(e.target.value)}
                    style={{padding:'7px',border:'1px solid #ddd',borderRadius:'5px',fontSize:'13px',width:'120px'}}/>
                  <button onClick={saveApiRate} style={{padding:'7px 16px',background:'#1e3a5f',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>حفظ السعر</button>
                  {apiRateMsg && <span style={{fontSize:'12px',color:apiRateMsg.includes('✅')?'#27ae60':'#e74c3c'}}>{apiRateMsg}</span>}
                </div>
                <p style={{fontSize:'11px',color:'#7a6000',margin:'8px 0 0'}}>يبقى هذا السعر ساريًا كل شهر حتى يتم تغييره يدويًا هنا.</p>
              </div>
            );
          })()}
          <div style={{marginBottom:'12px'}}>
            <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'5px'}}>نص التحية</label>
            <textarea value={info.whatsapp_greeting||''} onChange={e=>setInfo({...info,whatsapp_greeting:e.target.value})} rows={3}
              style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',boxSizing:'border-box',resize:'vertical'}}/>
          </div>
          <div style={{marginBottom:'15px'}}>
            <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'5px'}}>نص الختام</label>
            <textarea value={info.whatsapp_closing||''} onChange={e=>setInfo({...info,whatsapp_closing:e.target.value})} rows={2}
              style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',boxSizing:'border-box',resize:'vertical'}}/>
          </div>
          <div style={{marginBottom:'15px',borderTop:'2px solid #eee',paddingTop:'15px'}}>
            <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'5px'}}>تخصيص قوالب الرسائل</label>
            <select value={msgTemplateType} onChange={e=>setMsgTemplateType(e.target.value)}
              style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',marginBottom:'10px',boxSizing:'border-box'}}>
              <option value="">-- اختر نوع الرسالة --</option>
              <option value="comprehensive">📊 التقرير الشامل</option>
              <option value="bill_current">📋 الفاتورة الحالية</option>
              <option value="account">💰 الحساب فقط</option>
              <option value="schedule">⚡ التشغيل فقط</option>
              <option value="expenses">📋 المصروفات فقط</option>
              <option value="bills_only">🔌 الفواتير فقط</option>
              <option value="both">📊 الحساب + التشغيل + المصروفات</option>
              <option value="group_summary">👥 ملخص جماعي</option>
              <option value="schedule_all">📅 جدول التشغيل - الكل</option>
              <option value="schedule_one">📅 جدول تشغيلك القادم - شريك</option>
            </select>
            {msgTemplateType === 'comprehensive' && (
              <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>

                <div style={{background:'#f0f7ff',padding:'10px',borderRadius:'8px',fontSize:'12px',color:'#555',direction:'rtl'}}>
                  <b>المتغيرات:</b> {'{اسم}'} {'{بئر}'} {'{تاريخ}'} {'{ساعات}'} {'{نسبة}'} {'{مستحق}'} {'{مدفوع}'} {'{رصيد_موجب}'} {'{رصيد_سالب}'} {'{رقم}'} {'{من}'} {'{إلى}'} {'{ساعات_ف}'} {'{مستحق_ف}'}
                </div>
                <div style={{background:'#f8f9fa',padding:'10px',borderRadius:'8px'}}>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'8px'}}>عناصر الرسالة</label>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'6px'}}>
                    <label style={{display:'flex',alignItems:'center',gap:'6px',fontSize:'12px'}}><input type="checkbox" checked={info.wa_comp_show_hours!==false} onChange={e=>setInfo({...info,wa_comp_show_hours:e.target.checked})}/> ⏱️ ساعات التشغيل</label>
                    <label style={{display:'flex',alignItems:'center',gap:'6px',fontSize:'12px'}}><input type="checkbox" checked={info.wa_comp_show_account!==false} onChange={e=>setInfo({...info,wa_comp_show_account:e.target.checked})}/> 💰 الحساب</label>
                    <label style={{display:'flex',alignItems:'center',gap:'6px',fontSize:'12px'}}><input type="checkbox" checked={info.wa_comp_show_bills!==false} onChange={e=>setInfo({...info,wa_comp_show_bills:e.target.checked})}/> 🔌 الفواتير</label>
                    <label style={{display:'flex',alignItems:'center',gap:'6px',fontSize:'12px'}}><input type="checkbox" checked={info.wa_comp_show_balance!==false} onChange={e=>setInfo({...info,wa_comp_show_balance:e.target.checked})}/> ✅ الرصيد</label>
                    <label style={{display:'flex',alignItems:'center',gap:'6px',fontSize:'12px'}}><input type="checkbox" checked={info.wa_comp_show_expenses!==false} onChange={e=>setInfo({...info,wa_comp_show_expenses:e.target.checked})}/> 📋 المصروفات</label>
                    <label style={{display:'flex',alignItems:'center',gap:'6px',fontSize:'12px'}}><input type="checkbox" checked={info.wa_comp_show_revenues!==false} onChange={e=>setInfo({...info,wa_comp_show_revenues:e.target.checked})}/> 💵 الإيرادات</label>
                  </div>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>🔴 نص التحية والافتتاح <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{اسم}'})</span></label>
                  <textarea value={info.wa_comp_opening||''} onChange={e=>setInfo({...info,wa_comp_opening:e.target.value})} rows={3}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>📊 عنوان التقرير</label>
                  <textarea value={info.wa_comp_title||''} onChange={e=>setInfo({...info,wa_comp_title:e.target.value})} rows={2}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>⏱️ نص قسم الساعات <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{ساعات} {نسبة}'})</span></label>
                  <textarea value={info.wa_comp_hours_body||''} onChange={e=>setInfo({...info,wa_comp_hours_body:e.target.value})} rows={2}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>💰 نص قسم الحساب <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{مستحق} {مدفوع}'})</span></label>
                  <textarea value={info.wa_comp_account_body||''} onChange={e=>setInfo({...info,wa_comp_account_body:e.target.value})} rows={2}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>✅ نص الرصيد الموجب <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{رصيد_موجب}'})</span></label>
                  <textarea value={info.wa_comp_bal_pos||''} onChange={e=>setInfo({...info,wa_comp_bal_pos:e.target.value})} rows={1}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>⚠️ نص الرصيد السالب <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{رصيد_سالب}'})</span></label>
                  <textarea value={info.wa_comp_bal_neg||''} onChange={e=>setInfo({...info,wa_comp_bal_neg:e.target.value})} rows={1}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>🔌 عنوان قسم الفواتير</label>
                  <input type="text" value={info.wa_comp_bills_txt||''} onChange={e=>setInfo({...info,wa_comp_bills_txt:e.target.value})}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>📄 نص كل فاتورة <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{رقم} {من} {إلى} {ساعات_ف} {مستحق_ف}'})</span></label>
                  <input type="text" value={info.wa_comp_bill_line||''} onChange={e=>setInfo({...info,wa_comp_bill_line:e.target.value})}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>🔴 نص الختام <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{تاريخ}'})</span></label>
                  <textarea value={info.wa_comp_footer||''} onChange={e=>setInfo({...info,wa_comp_footer:e.target.value})} rows={2}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
              </div>
            )}
            {(msgTemplateType === 'account' || msgTemplateType === 'schedule' || msgTemplateType === 'expenses' || msgTemplateType === 'bills_only' || msgTemplateType === 'both') && (
              <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
                <div style={{background:'#f0f7ff',padding:'10px',borderRadius:'8px',fontSize:'12px',color:'#555',direction:'rtl'}}>
                  <b>هذه الرسائل تستخدم نفس إعدادات "💰 الحساب فقط" أعلاه</b><br/>
                  عدّل النصوص في قسم "💰 الحساب فقط" وستنعكس هنا تلقائياً ✅
                </div>
              </div>
            )}
            {msgTemplateType === 'schedule_all' && (
              <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
                <div style={{background:'#f0f7ff',padding:'10px',borderRadius:'8px',fontSize:'12px',color:'#555',direction:'rtl'}}>
                  <b>المتغيرات:</b> {'{تاريخ}'} {'{يوم}'} {'{شريك}'}
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>📅 عنوان الجدول</label>
                  <input type="text" value={info.wa_sched_all_title||''} onChange={e=>setInfo({...info,wa_sched_all_title:e.target.value})}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>📝 نص كل صف <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{تاريخ} {يوم} {شريك}'})</span></label>
                  <input type="text" value={info.wa_sched_all_row||''} onChange={e=>setInfo({...info,wa_sched_all_row:e.target.value})}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>🔴 نص الختام <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{تاريخ}'})</span></label>
                  <textarea value={info.wa_sched_all_footer||''} onChange={e=>setInfo({...info,wa_sched_all_footer:e.target.value})} rows={2}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
              </div>
            )}
            {msgTemplateType === 'schedule_one' && (
              <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
                <div style={{background:'#f0f7ff',padding:'10px',borderRadius:'8px',fontSize:'12px',color:'#555',direction:'rtl'}}>
                  <b>المتغيرات:</b> {'{اسم}'} {'{تاريخ}'} {'{يوم}'}
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>🔴 نص الافتتاح <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{اسم}'})</span></label>
                  <input type="text" value={info.wa_sched_one_opening||''} onChange={e=>setInfo({...info,wa_sched_one_opening:e.target.value})}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>📅 عنوان الجدول</label>
                  <input type="text" value={info.wa_sched_one_title||''} onChange={e=>setInfo({...info,wa_sched_one_title:e.target.value})}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>📝 نص كل صف <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{تاريخ} {يوم}'})</span></label>
                  <input type="text" value={info.wa_sched_one_row||''} onChange={e=>setInfo({...info,wa_sched_one_row:e.target.value})}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>⚠️ نص عدم وجود مواعيد</label>
                  <input type="text" value={info.wa_sched_one_empty||''} onChange={e=>setInfo({...info,wa_sched_one_empty:e.target.value})}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>🔴 نص الختام <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{تاريخ}'})</span></label>
                  <textarea value={info.wa_sched_one_footer||''} onChange={e=>setInfo({...info,wa_sched_one_footer:e.target.value})} rows={2}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
              </div>
            )}
            {msgTemplateType === 'group_summary' && (
              <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
                <div style={{background:'#f0f7ff',padding:'10px',borderRadius:'8px',fontSize:'12px',color:'#555',direction:'rtl'}}>
                  <b>المتغيرات:</b> {'{اسم}'} {'{تاريخ}'} {'{مستحق}'} {'{مدفوع}'} {'{رصيد}'}
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>🔴 نص التحية</label>
                  <textarea value={info.whatsapp_greeting||''} onChange={e=>setInfo({...info,whatsapp_greeting:e.target.value})} rows={2}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>🔴 نص الختام <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{تاريخ}'})</span></label>
                  <textarea value={info.wa_group_footer||''} onChange={e=>setInfo({...info,wa_group_footer:e.target.value})} rows={2}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
              </div>
            )}
            {msgTemplateType === 'bill_current' && (
              <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
                <div style={{background:'#f0f7ff',padding:'10px',borderRadius:'8px',fontSize:'12px',color:'#555',direction:'rtl'}}>
                  <b>المتغيرات:</b> {'{اسم}'} {'{تاريخ}'} {'{من}'} {'{إلى}'} {'{ساعات}'} {'{يوم}'} {'{نوع}'} {'{رصيد_موجب}'} {'{رصيد_سالب}'}
                </div>
                <div style={{background:'#f8f9fa',padding:'10px',borderRadius:'8px'}}>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'8px'}}>عناصر الرسالة</label>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'6px'}}>
                    <label style={{display:'flex',alignItems:'center',gap:'6px',fontSize:'12px'}}><input type="checkbox" checked={info.wa_bill_show_sessions!==false} onChange={e=>setInfo({...info,wa_bill_show_sessions:e.target.checked})}/> 📅 جدول التشغيل</label>
                    <label style={{display:'flex',alignItems:'center',gap:'6px',fontSize:'12px'}}><input type="checkbox" checked={info.wa_bill_show_balance!==false} onChange={e=>setInfo({...info,wa_bill_show_balance:e.target.checked})}/> ✅ الرصيد</label>
                  </div>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>🔴 نص الافتتاح <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{اسم}'})</span></label>
                  <textarea value={info.wa_bill_opening||''} onChange={e=>setInfo({...info,wa_bill_opening:e.target.value})} rows={2}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>📋 عنوان الفاتورة</label>
                  <input type="text" value={info.wa_bill_title||''} onChange={e=>setInfo({...info,wa_bill_title:e.target.value})}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>📅 عنوان جدول التشغيل</label>
                  <input type="text" value={info.wa_bill_hours_title||''} onChange={e=>setInfo({...info,wa_bill_hours_title:e.target.value})}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>📝 نص كل جلسة <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{يوم} {تاريخ} {نوع} {ساعات}'})</span></label>
                  <input type="text" value={info.wa_bill_session_line||''} onChange={e=>setInfo({...info,wa_bill_session_line:e.target.value})}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>✅ نص الرصيد صفر</label>
                  <input type="text" value={info.wa_bill_bal_zero||''} onChange={e=>setInfo({...info,wa_bill_bal_zero:e.target.value})}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>✅ نص الرصيد الموجب <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{رصيد_موجب}'})</span></label>
                  <input type="text" value={info.wa_bill_bal_pos||''} onChange={e=>setInfo({...info,wa_bill_bal_pos:e.target.value})}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>⚠️ نص الرصيد السالب <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{رصيد_سالب}'})</span></label>
                  <textarea value={info.wa_bill_bal_neg||''} onChange={e=>setInfo({...info,wa_bill_bal_neg:e.target.value})} rows={3}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>🔴 نص الختام <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{تاريخ}'})</span></label>
                  <textarea value={info.wa_bill_footer||''} onChange={e=>setInfo({...info,wa_bill_footer:e.target.value})} rows={2}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
              </div>
            )}
            {msgTemplateType === 'account' && (
              <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>📌 نص التحية والافتتاح</label>
                  <textarea value={info.whatsapp_greeting||''} onChange={e=>setInfo({...info,whatsapp_greeting:e.target.value})} rows={3}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>⏱️ نص قسم الساعات <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{ساعات} {نسبة}'})</span></label>
                  <textarea value={info.wa_acc_hours_txt||''} onChange={e=>setInfo({...info,wa_acc_hours_txt:e.target.value})} rows={2}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>💰 نص قسم الحساب <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{مستحق} {مدفوع}'})</span></label>
                  <textarea value={info.wa_acc_account_txt||''} onChange={e=>setInfo({...info,wa_acc_account_txt:e.target.value})} rows={3}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>✅ نص حالة الرصيد الموجب أو الصفر <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{رصيد_موجب}'})</span></label>
                  <textarea value={info.wa_acc_bal_pos||''} onChange={e=>setInfo({...info,wa_acc_bal_pos:e.target.value})} rows={2}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>⚠️ نص حالة الرصيد السالب <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{رصيد_سالب}'})</span></label>
                  <textarea value={info.wa_acc_bal_neg||''} onChange={e=>setInfo({...info,wa_acc_bal_neg:e.target.value})} rows={2}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>📋 عنوان قسم الفواتير</label>
                  <input type="text" value={info.wa_acc_bills_title||''} onChange={e=>setInfo({...info,wa_acc_bills_title:e.target.value})}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>📄 نص كل فاتورة <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{رقم} {من} {إلى} {ساعات_ف} {مستحق_ف}'})</span></label>
                  <input type="text" value={info.wa_acc_bill_line||''} onChange={e=>setInfo({...info,wa_acc_bill_line:e.target.value})}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>📌 نص الختام <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(يستخدم: {'{تاريخ}'})</span></label>
                  <textarea value={info.wa_acc_footer||''} onChange={e=>setInfo({...info,wa_acc_footer:e.target.value})} rows={2}
                    style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
                </div>
              </div>
            )}
          </div>
          <div style={{marginBottom:'16px'}}>
            <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>💡 تعليمات رسائل واتساب <span style={{fontSize:'11px',color:'#888',fontWeight:400}}>(تظهر للمدير في تبويب واتساب)</span></label>
            <textarea value={info.whatsapp_api_note||''} onChange={e=>setInfo({...info,whatsapp_api_note:e.target.value})} rows={4}
              style={{width:'100%',padding:'7px',border:'1px solid #ccc',borderRadius:'5px',fontSize:'13px',direction:'rtl',resize:'vertical',boxSizing:'border-box'}}/>
          </div>
          <div style={{display:'flex',gap:'10px',flexWrap:'wrap',alignItems:'center'}}>
            {msgTemplateType === 'account' && (
              <button onClick={()=>setInfo({...info,
                whatsapp_greeting:'السلام عليكم ورحمة الله وبركاته',
                wa_acc_hours_txt:'⏱️ *ساعات التشغيل:*\n• إجمالي ساعاتك: *{ساعات}* ساعة ({نسبة}% من الإجمالي)',
                wa_acc_account_txt:'💰 *الحساب:*\n• المستحق عليك: *{مستحق}* ريال\n• إجمالي ما دفعت: *{مدفوع}* ريال',
                wa_acc_bal_pos:'✅ *مسدد* · ورصيدك ({رصيد_موجب}) ريال',
                wa_acc_bal_neg:'⚠️ *لم يسدد* · والمبلغ المطلوب سداده ({رصيد_سالب}) ريال',
                wa_acc_bills_title:'📋 *تفصيل الفواتير:*',
                wa_acc_bill_line:'• فاتورة {رقم} ({من} ← {إلى}) · ساعاتك: *{ساعات_ف}* · مستحقك: *{مستحق_ف}* ريال',
                wa_acc_footer:'نسأل الله لكم التوفيق والسداد\n📆 تاريخ الإرسال: {تاريخ}',
              })}
                style={{padding:'9px 16px',background:'#e67e22',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>
                🔄 استعادة الافتراضي
              </button>
            )}
            <button onClick={()=>save('save_info',info)} disabled={saving}
              style={{padding:'9px 20px',background:'#27ae60',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>
              💾 حفظ اعدادات الواتساب
            </button>
            {(msgTemplateType === 'account' || msgTemplateType === 'schedule' || msgTemplateType === 'expenses' || msgTemplateType === 'bills_only' || msgTemplateType === 'both') && (
              <button onClick={()=>{
                const sep = '─'.repeat(28);
                const name = 'اسم الشريك';
                let msg = `💧 *بئر الشراكة ( اسم الشراكة )*\n`;
                msg += `المكرم / ${name}\nسلمكم الله\n${info.whatsapp_greeting||''}\n${sep}\n`;
                if (msgTemplateType === 'account' || msgTemplateType === 'both') {
                  let accTxt = (info.wa_acc_account_txt||'').replaceAll('{مستحق}','١٠٬٠٠٠').replaceAll('{مدفوع}','١٠٬٠٠٠');
                  msg += `\n${accTxt}\n• ${(info.wa_acc_bal_pos||'').replaceAll('{رصيد_موجب}','٠٫٣٩')}\n`;
                }
                if (msgTemplateType === 'schedule' || msgTemplateType === 'both') {
                  let hTxt = (info.wa_acc_hours_txt||'').replaceAll('{ساعات}','١٠٠').replaceAll('{نسبة}','١٥');
                  msg += `\n${hTxt}\n`;
                }
                if (msgTemplateType === 'expenses' || msgTemplateType === 'both') {
                  msg += `\n📋 *المصروفات:*\n• نصيبك من المصروفات: *١٠٬٠٠٠* ريال\n`;
                }
                if (msgTemplateType === 'bills_only' || msgTemplateType === 'both') {
                  msg += `\n${info.wa_acc_bills_title||''}\n`;
                  msg += `${(info.wa_acc_bill_line||'').replaceAll('{رقم}','١').replaceAll('{من}','2026-01-01').replaceAll('{إلى}','2026-02-01').replaceAll('{ساعات_ف}','٢٠').replaceAll('{مستحق_ف}','٥٠٠')}\n`;
                }
                msg += `\n${sep}\n${(info.wa_acc_footer||'').replaceAll('{تاريخ}', new Date().toLocaleDateString('ar-SA'))}`;
                setPreviewMsg(msg);
              }}
                style={{padding:'9px 16px',background:'#8e44ad',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>
                👁️ معاينة
              </button>
            )}
            {msgTemplateType === 'schedule_all' && (
              <button onClick={()=>{
                const sep = '─'.repeat(28);
                let msg = `💧 *بئر الشراكة ( اسم الشراكة )*\n${sep}\n`;
                msg += `${info.wa_sched_all_title||''}\nمن 2026-06-01 إلى 2026-06-30\n${sep}\n`;
                ['2026-06-01 (الأحد)','2026-06-08 (الأحد)','2026-06-15 (الأحد)'].forEach((d,i) => {
                  msg += `${(info.wa_sched_all_row||'').replaceAll('{تاريخ}',d.split(' ')[0]).replaceAll('{يوم}',d.split('(')[1]?.replace(')','') ||'').replaceAll('{شريك}','اسم الشريك')}\n`;
                });
                msg += `${sep}\n${(info.wa_sched_all_footer||'').replaceAll('{تاريخ}', new Date().toLocaleDateString('ar-SA'))}`;
                setPreviewMsg(msg);
              }}
                style={{padding:'9px 16px',background:'#8e44ad',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>
                👁️ معاينة
              </button>
            )}
            {msgTemplateType === 'schedule_all' && (
              <button onClick={()=>setInfo({...info,
                wa_sched_all_title:'📅 *جدول مواعيد التشغيل*',
                wa_sched_all_row:'📆 *{تاريخ}* ({يوم}) ← 👤 {شريك}',
                wa_sched_all_footer:'نسأل الله لكم التوفيق والسداد 🤲\n📅 تاريخ الإرسال: {تاريخ}',
              })}
                style={{padding:'9px 16px',background:'#e67e22',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>
                🔄 استعادة الافتراضي
              </button>
            )}
            {msgTemplateType === 'schedule_one' && (
              <button onClick={()=>{
                const sep = '─'.repeat(28);
                let msg = `💧 *بئر الشراكة ( اسم الشراكة )*\n`;
                msg += `${(info.wa_sched_one_opening||'').replaceAll('{اسم}','اسم الشريك')}\n`;
                msg += `${info.whatsapp_greeting||''}\n${sep}\n`;
                msg += `${info.wa_sched_one_title||''}\nمن 2026-06-01 إلى 2026-06-30\n${sep}\n`;
                msg += `${(info.wa_sched_one_row||'').replaceAll('{تاريخ}','2026-06-01').replaceAll('{يوم}','الأحد')}\n`;
                msg += `${sep}\n${(info.wa_sched_one_footer||'').replaceAll('{تاريخ}', new Date().toLocaleDateString('ar-SA'))}`;
                setPreviewMsg(msg);
              }}
                style={{padding:'9px 16px',background:'#8e44ad',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>
                👁️ معاينة
              </button>
            )}
            {msgTemplateType === 'schedule_one' && (
              <button onClick={()=>setInfo({...info,
                wa_sched_one_opening:'المكرم الأخ / {اسم} حفظه الله',
                wa_sched_one_title:'📅 *جدول مواعيد تشغيلك*',
                wa_sched_one_row:'📆 *{تاريخ}* ({يوم})',
                wa_sched_one_empty:'لا توجد مواعيد تشغيل لك خلال هذه الفترة',
                wa_sched_one_footer:'نسأل الله لكم التوفيق 🤲\n📅 تاريخ الإرسال: {تاريخ}',
              })}
                style={{padding:'9px 16px',background:'#e67e22',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>
                🔄 استعادة الافتراضي
              </button>
            )}
            {msgTemplateType === 'group_summary' && (
              <button onClick={()=>{
                const sep = '─'.repeat(28);
                let msg = `💧 *بئر الشراكة ( اسم الشراكة )*\n${info.whatsapp_greeting||''}\n${sep}\n`;
                msg += `\n💰 *ملخص حسابات الشركاء:*\n\n`;
                msg += `✅ *محمد بن عبدالله*\n   المستحق: ١٠٬٠٠٠ | دفع: ١٠٬٠٠٠\n   مسدد: ٠٫٠٠ ريال\n\n`;
                msg += `⚠️ *أحمد بن علي*\n   المستحق: ٨٬٠٠٠ | دفع: ٦٬٠٠٠\n   مديون: ٢٬٠٠٠ ريال\n\n`;
                msg += `📅 ${new Date().toLocaleDateString('ar-SA')}\n`;
                if(info.wa_group_footer) msg += `${info.wa_group_footer.replaceAll('{تاريخ}', new Date().toLocaleDateString('ar-SA'))}`;
                setPreviewMsg(msg);
              }}
                style={{padding:'9px 16px',background:'#8e44ad',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>
                👁️ معاينة
              </button>
            )}
            {msgTemplateType === 'bill_current' && (
              <button onClick={()=>{
                const sep = '─'.repeat(28);
                const name = 'اسم الشريك';
                let msg = `💧 *بئر الشراكة ( اسم الشراكة )*\n`;
                msg += `${(info.wa_bill_opening||'').replaceAll('{اسم}', name)}\n`;
                msg += `${info.whatsapp_greeting||''}\n${sep}\n`;
                msg += `${info.wa_bill_title||''}\nخلال الفترة من 2026-01-01 إلى 2026-02-01\n${sep}\n`;
                msg += `⏱️ ساعات التشغيل مدة الفاتورة: *٣٢* ساعة\n`;
                if (info.wa_bill_show_sessions!==false) {
                  msg += `${sep}\n${info.wa_bill_hours_title||''}\n`;
                  msg += `${(info.wa_bill_session_line||'').replaceAll('{يوم}','الأحد').replaceAll('{تاريخ}','2026-01-05').replaceAll('{نوع}','أساسي').replaceAll('{ساعات}','٨ ساعات')}\n`;
                }
                msg += `${sep}\n`;
                if (info.wa_bill_show_balance!==false) {
                  msg += `${(info.wa_bill_bal_pos||'').replaceAll('{رصيد_موجب}','٠٫٣٩')}\n`;
                }
                msg += `${sep}\n${(info.wa_bill_footer||'').replaceAll('{تاريخ}', new Date().toLocaleDateString('ar-SA'))}`;
                setPreviewMsg(msg);
              }}
                style={{padding:'9px 16px',background:'#8e44ad',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>
                👁️ معاينة
              </button>
            )}
            {msgTemplateType === 'bill_current' && (
              <button onClick={()=>setInfo({...info,
                wa_bill_opening:'المكرم الأخ / {اسم} حفظكم الله',
                wa_bill_title:'📋 *صدرت الفاتورة الحالية*',
                wa_bill_hours_title:'📅 *أيام/ساعات التشغيل مدة الفاتورة:*',
                wa_bill_session_line:'• يوم {يوم} {تاريخ} - {نوع} - مدة التشغيل: *{ساعات}*',
                wa_bill_bal_zero:'• الرصيد الحالي: *صفر* ✅',
                wa_bill_bal_pos:'• الرصيد الحالي: له رصيد *{رصيد_موجب}* ريال ✅',
                wa_bill_bal_neg:'• الرصيد الحالي: مدين *{رصيد_سالب}* ريال ⚠️\n• المبلغ المطلوب سداده: *{رصيد_سالب}* ريال\n• نأمل السداد في مدة أقصاها يومين بعد وصول الرسالة',
                wa_bill_footer:'• نشكر لكم مبادرتكم كما تعودنا منكم 🤲\n📆 تاريخ الإرسال: {تاريخ}',
                wa_bill_show_sessions:true,
                wa_bill_show_balance:true,
              })}
                style={{padding:'9px 16px',background:'#e67e22',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>
                🔄 استعادة الافتراضي
              </button>
            )}
            {msgTemplateType === 'comprehensive' && (
              <button onClick={()=>{
                const sep = '─'.repeat(28);
                const name = 'اسم الشريك';
                let msg = `💧 *بئر الشراكة ( اسم الشراكة )*\n${sep}\n`;
                msg += `${(info.wa_comp_opening||'').replaceAll('{اسم}', name)}\n`;
                msg += `${info.whatsapp_greeting||''}\n`;
                if (info.wa_comp_greeting) msg += `${info.wa_comp_greeting}\n`;
                msg += `${sep}\n${info.wa_comp_title||''}\nخلال الفترة من 2026-01-01 إلى 2026-06-18\n${sep}\n`;
                if (info.wa_comp_show_expenses!==false) msg += `💰 *المصروفات:*\n• مثال: *١٠٬٠٠٠* ريال\n${sep}\n`;
                if (info.wa_comp_show_revenues!==false) msg += `💵 *الإيرادات:*\n• مثال: *١٠٬٠٠٠* ريال\n${sep}\n`;
                if (info.wa_comp_show_hours!==false) {
                  msg += `⏱️ *ساعات التشغيل:*\n`;
                  msg += `${(info.wa_comp_hours_body||'').replaceAll('{ساعات}','١٠٠').replaceAll('{نسبة}','١٥')}\n${sep}\n`;
                }
                if (info.wa_comp_show_bills!==false) {
                  msg += `${info.wa_comp_bills_txt||''}\n`;
                  msg += `${(info.wa_comp_bill_line||'').replaceAll('{رقم}','١').replaceAll('{من}','2026-01-01').replaceAll('{إلى}','2026-02-01').replaceAll('{ساعات_ف}','٢٠').replaceAll('{مستحق_ف}','٥٠٠')}\n${sep}\n`;
                }
                if (info.wa_comp_show_balance!==false) {
                  msg += `• ${info.wa_comp_bal_pos||''}\n`;
                }
                if (info.wa_comp_show_account!==false) {
                  msg += `${sep}\n${(info.wa_comp_account_body||'').replaceAll('{مستحق}','١٠٬٠٠٠').replaceAll('{مدفوع}','١٠٬٠٠٠')}\n`;
                }
                msg += `${sep}\n${(info.wa_comp_footer||'').replaceAll('{تاريخ}', new Date().toLocaleDateString('ar-SA'))}`;
                setPreviewMsg(msg);
              }}
                style={{padding:'9px 16px',background:'#8e44ad',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>
                👁️ معاينة
              </button>
            )}
            {msgTemplateType === 'comprehensive' && (
              <button onClick={()=>setInfo({...info,
                wa_comp_show_hours:true, wa_comp_show_account:true, wa_comp_show_bills:true,
                wa_comp_show_balance:true, wa_comp_show_expenses:true, wa_comp_show_revenues:true,
                wa_comp_opening:'المكرم الأخ / {اسم} حفظكم الله',
                wa_comp_greeting:'وأسعد الله أوقاتك بكل خير',
                wa_comp_title:'📊 *تقرير شامل*\n( المصروفات - الإيرادات - الفواتير - عدد ساعات التشغيل )',
                wa_comp_hours_body:'• أيام/ساعات التشغيل الخاصة بكم: *{ساعات}*\n• نسبة تشغيلكم: *{نسبة}٪*',
                wa_comp_account_body:'• المستحق عليكم: *{مستحق}* ريال\n• إجمالي ما دفعتم: *{مدفوع}* ريال',
                wa_comp_bal_pos:'✅ *مسدد* · ورصيدكم ({رصيد_موجب}) ريال',
                wa_comp_bal_neg:'⚠️ *لم يسدد* · والمبلغ المطلوب سداده ({رصيد_سالب}) ريال',
                wa_comp_bills_txt:'🔌 *الفواتير:*',
                wa_comp_bill_line:'• فاتورة {رقم} ({من} ← {إلى}) · ساعاتكم: *{ساعات_ف}* · مستحقكم: *{مستحق_ف}* ريال',
                wa_comp_footer:'للإحاطة والاطلاع 🤝\n📆 تاريخ الإرسال: {تاريخ}',
              })}
                style={{padding:'9px 16px',background:'#e67e22',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>
                🔄 استعادة الافتراضي
              </button>
            )}
          </div>
          {previewMsg && (
            <div style={{marginTop:'16px',background:'#f8f9fa',border:'1px solid #ddd',borderRadius:'10px',padding:'16px',direction:'rtl'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'10px'}}>
                <b style={{fontSize:'13px',color:'#1e3a5f'}}>👁️ معاينة الرسالة</b>
                <button onClick={()=>setPreviewMsg('')} style={{background:'none',border:'none',cursor:'pointer',fontSize:'16px',color:'#999'}}>✕</button>
              </div>
              <pre style={{whiteSpace:'pre-wrap',fontFamily:'Tahoma,Arial,sans-serif',fontSize:'13px',lineHeight:'1.7',margin:0,color:'#333',direction:'rtl',textAlign:'right'}}>
                {previewMsg}
              </pre>
            </div>
          )}
        </div>
      )}

      {section === 'lists' && (
        <div style={{background:'white',padding:'20px',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
          <h4 style={{margin:'0 0 15px',color:'#1e3a5f',borderBottom:'2px solid #eee',paddingBottom:'8px'}}>ادارة قوائم الوصف المنسدلة</h4>
          <div style={{marginBottom:'15px'}}>
            <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'5px'}}>اصناف المصروفات</label>
            <TagInput value={info.expense_categories||''} onChange={v=>setInfo({...info,expense_categories:v})} placeholder="اضف صنفا جديدا..."/>
          </div>
          <div style={{marginBottom:'15px'}}>
            <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'5px'}}>اوصاف الدفعات</label>
            <TagInput value={info.payment_descriptions||''} onChange={v=>setInfo({...info,payment_descriptions:v})} placeholder="اضف وصفا جديدا..."/>
          </div>
          <button onClick={()=>save('save_info',info)} disabled={saving}
            style={{padding:'9px 20px',background:'#27ae60',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>
            حفظ القوائم
          </button>
        </div>
      )}

      {section === 'slots' && <Slots partnership={partnership} />}

      {section === 'backup' && (
        <div style={{background:'white',padding:'20px',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)',border:'2px solid #1e3a5f'}}>
          <h4 style={{margin:'0 0 15px',color:'#1e3a5f',borderBottom:'2px solid #eee',paddingBottom:'8px'}}>💾 نسخة احتياطية كاملة</h4>

          {false && (<div style={{display:'flex',gap:'15px',flexWrap:'wrap',marginBottom:'20px'}}>
            <button onClick={async()=>{
              try {
                const res = await fetch('/api/backup/', {headers:{'X-Requested-With':'XMLHttpRequest'}});
                const blob = await res.blob();
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'wells_backup_' + new Date().toISOString().slice(0,19).replace(/[:.]/g,'-') + '.zip';
                document.body.appendChild(a); a.click(); document.body.removeChild(a);
                URL.revokeObjectURL(url);
              } catch(e){ alert('خطأ: ' + e.message); }
            }} style={{padding:'12px 20px',background:'#1e3a5f',color:'white',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'13px',fontWeight:'bold'}}>
              💾 نسخة كاملة (كود + بيانات)
            </button>
            <button onClick={async()=>{
              try {
                const res = await fetch('/api/backup-db/', {headers:{'X-Requested-With':'XMLHttpRequest'}});
                const blob = await res.blob();
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'db_backup_' + new Date().toISOString().slice(0,19).replace(/[:.]/g,'-') + '.sql';
                document.body.appendChild(a); a.click(); document.body.removeChild(a);
                URL.revokeObjectURL(url);
              } catch(e){ alert('خطأ: ' + e.message); }
            }} style={{padding:'12px 20px',background:'#27ae60',color:'white',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'13px',fontWeight:'bold'}}>
              🗄️ نسخة البيانات فقط (SQL)
            </button>
            <button onClick={async()=>{
              try {
                const res = await fetch(`/api/backup-partnership/${partnership.id}/`, {headers:{'X-Requested-With':'XMLHttpRequest'}});
                if(!res.ok){alert('فشل');return;}
                const blob = await res.blob();
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'partnership_backup_' + new Date().toISOString().slice(0,19).replace(/[:.]/g,'-') + '.zip';
                document.body.appendChild(a); a.click(); document.body.removeChild(a);
                URL.revokeObjectURL(url);
              } catch(e){ alert('خطأ: ' + e.message); }
            }} style={{padding:'12px 20px',background:'#8e44ad',color:'white',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'13px',fontWeight:'bold'}}>
              📦 بيانات هذه الشراكة فقط
            </button>
          </div>)}
          <div style={{marginBottom:'15px'}}>
              <button onClick={async()=>{
                try{
                  const token=localStorage.getItem('token');
                  const pid=partnership.id;
                  const res=await fetch('/api/backup-partnership/'+pid+'/',{headers:{'X-Requested-With':'XMLHttpRequest','Authorization':'Token '+token}});
                  const blob=await res.blob();
                  const a=document.createElement('a');
                  a.href=URL.createObjectURL(blob);
                  a.download='backup_partnership_'+new Date().toISOString().slice(0,10)+'.zip';
                  document.body.appendChild(a);a.click();document.body.removeChild(a);
                }catch(e){alert('خطأ: '+e.message);}
              }} style={{padding:'12px 20px',background:'#8e44ad',color:'white',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'13px',fontWeight:'bold'}}>
                📦 تنزيل نسخة بيانات الشراكة
              </button>
            </div>
          <div style={{background:'#f3e5f5',padding:'15px',borderRadius:'8px',border:'1px solid #8e44ad',marginBottom:'15px'}}>
            <p style={{margin:'0 0 8px',fontWeight:'bold',color:'#6a1b9a',fontSize:'13px'}}>📦 استعادة بيانات هذه الشراكة من ملف ZIP</p>
            <p style={{margin:'0 0 12px',fontSize:'12px',color:'#6a1b9a'}}>سيتم استبدال بيانات هذه الشراكة فقط من الملف المختار</p>
            <input type='file' accept='.zip' id='restore-partnership-file' style={{display:'none'}} onChange={async(e)=>{
              const file = e.target.files[0];
              if(!file) return;
              const val = window.prompt('تحذير: سيتم استبدال بيانات هذه الشراكة!\nاكتب كلمة استعادة للتأكيد:');
              if(val === null){e.target.value='';return;}
              if(val.trim() !== 'استعادة'){alert('الكلمة غير صحيحة!');e.target.value='';return;}
              const fd = new FormData();
              fd.append('zip_file', file);
              try {
                const res = await fetch(`/api/restore-partnership/${partnership.id}/`, {method:'POST', body:fd, headers:{'X-CSRFToken': document.cookie.match(/csrftoken=([^;]+)/)?.[1]||''}});
                const data = await res.json();
                if(data.ok){ alert('تمت الاستعادة بنجاح!'); window.location.reload(); }
                else { alert('فشل: ' + (data.error||'خطأ')); }
              } catch(e){ alert('خطأ: ' + e.message); }
              e.target.value='';
            }}/>
            <button onClick={()=>document.getElementById('restore-partnership-file').click()}
              style={{padding:'10px 20px',background:'#8e44ad',color:'white',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'13px',fontWeight:'bold'}}>
              📥 استعادة بيانات الشراكة من ZIP
            </button>
          </div>
          {false && <div style={{background:'#fff3cd',padding:'15px',borderRadius:'8px',border:'1px solid #ffc107',marginBottom:'15px'}}>
            <p style={{margin:'0 0 10px',fontWeight:'bold',color:'#856404',fontSize:'13px'}}>⚠️ استعادة البيانات من ملف SQL</p>
            <input type='file' accept='.sql' id='restore-file' style={{display:'none'}} onChange={async(e)=>{
              const file = e.target.files[0];
              if(!file) return;
              const val = window.prompt('تحذير: سيتم حذف جميع البيانات الحالية!\nاكتب كلمة استعادة للتأكيد:');
              if(val === null){e.target.value='';return;}
              if(val.trim() !== 'استعادة'){alert('الكلمة غير صحيحة! تم الإلغاء.');e.target.value='';return;}
              if(!window.confirm('هل أنت متأكد تماماً؟ لا يمكن التراجع!')) {e.target.value='';return;}
              const fd = new FormData();
              fd.append('sql_file', file);
              try {
                const res = await fetch('/api/restore-db/', {method:'POST', body:fd, headers:{'X-CSRFToken': document.cookie.match(/csrftoken=([^;]+)/)?.[1]||''}});
                const data = await res.json();
                if(data.ok){ alert('تمت الاستعادة بنجاح! سيتم تحديث الصفحة.'); window.location.reload(); }
                else { alert('فشل: ' + (data.error||'خطأ غير معروف')); }
              } catch(e){ alert('خطأ: ' + e.message); }
              e.target.value='';
            }}/>
            <button onClick={()=>document.getElementById('restore-file').click()}
              style={{padding:'10px 20px',background:'#dc3545',color:'white',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'13px',fontWeight:'bold'}}>
              📥 استعادة من ملف SQL
            </button>
          </div>}
        </div>
      )}
      {section === 'danger' && (
        <div style={{background:'white',padding:'20px',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)',border:'2px solid #e74c3c'}}>
          <h4 style={{margin:'0 0 15px',color:'#e74c3c',borderBottom:'2px solid #eee',paddingBottom:'8px'}}>⚠️ حذف الشراكة نهائياً</h4>
          <p style={{color:'#666',marginBottom:'15px',fontSize:'13px'}}>هذا الإجراء لا يمكن التراجع عنه. سيتم حذف جميع البيانات المرتبطة بهذه الشراكة.</p>
          <p style={{color:'#e74c3c',fontWeight:'bold',marginBottom:'10px',fontSize:'13px'}}>اكتب اسم الشراكة للتأكيد:</p>
          <p style={{color:'#1e3a5f',fontWeight:'bold',marginBottom:'10px',fontSize:'13px',background:'#f8f9fa',padding:'8px',borderRadius:'6px'}}>{partnership.name}</p>
          <input
            placeholder="اكتب اسم الشراكة هنا..."
            id="delete-confirm-input"
            style={{width:'100%',padding:'10px',border:'2px solid #e74c3c',borderRadius:'6px',fontSize:'13px',boxSizing:'border-box',marginBottom:'15px'}}
          />
          <button onClick={async()=>{
            const val = document.getElementById('delete-confirm-input').value;
            if(val !== partnership.name){alert('اسم الشراكة غير صحيح!');return;}
            if(!window.confirm('هل أنت متأكد تماماً من حذف هذه الشراكة؟')) return;
            await API.delete(`/partnerships/${partnership.id}/`);
            if(onDelete) onDelete();
          }} style={{padding:'10px 20px',background:'#e74c3c',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px',fontWeight:'bold'}}>
            🗑️ حذف الشراكة نهائياً
          </button>
        </div>
      )}
      {section === 'security' && (
        <div style={{background:'white',padding:'20px',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
          <h4 style={{margin:'0 0 15px',color:'#1e3a5f',borderBottom:'2px solid #eee',paddingBottom:'8px'}}>كلمة مرور لوحة التحكم</h4>
          <p style={{fontSize:'12px',color:'#888',margin:'0 0 12px'}}>{data?.settings?.has_password?'كلمة المرور مفعلة':'لا توجد كلمة مرور حاليا'}</p>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px',marginBottom:'12px',maxWidth:'400px'}}>
            <div><label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'5px'}}>كلمة المرور الجديدة</label>
              <input type="password" value={newPassword} onChange={e=>setNewPassword(e.target.value)}
                style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',boxSizing:'border-box'}}/></div>
            <div><label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'5px'}}>تاكيد كلمة المرور</label>
              <input type="password" value={confirmPassword} onChange={e=>setConfirmPassword(e.target.value)}
                style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',boxSizing:'border-box'}}/></div>
          </div>
          <button onClick={()=>{
            if(newPassword!==confirmPassword){setMsg('كلمتا المرور غير متطابقتان');return;}
            save('change_password',{password:newPassword});
            setNewPassword('');setConfirmPassword('');
          }} style={{padding:'9px 20px',background:'#e67e22',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px'}}>
            تغيير كلمة المرور
          </button>
        </div>
      )}
      {section === 'users' && (
        <div style={{background:'white',padding:'20px',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
          <UserManagement partnerships={[partnership]} />
        </div>
      )}
      {section === 'licenses' && (
        <div style={{background:'white',padding:'20px',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
          <h4 style={{margin:'0 0 15px',color:'#1e3a5f',borderBottom:'2px solid #eee',paddingBottom:'8px'}}>🔑 تراخيص برنامج WellManager</h4>
          <div style={{background:'#f8f9fa',padding:'15px',borderRadius:'8px',marginBottom:'20px',border:'1px solid #e0e0e0'}}>
            <h5 style={{margin:'0 0 12px',color:'#1e3a5f'}}>➕ إضافة ترخيص جديد</h5>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'10px'}}>
              <div>
                <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>رقم الجهاز (Device ID) *</label>
                <input value={licForm.device_id} onChange={e=>setLicForm({...licForm,device_id:e.target.value})}
                  placeholder="مثال: 2137D887FE3CB223"
                  style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',boxSizing:'border-box',fontFamily:'Courier New'}}/>
              </div>
              <div>
                <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>اسم صاحب الترخيص *</label>
                <input value={licForm.owner_name} onChange={e=>setLicForm({...licForm,owner_name:e.target.value})}
                  placeholder="مثال: سعود العتيبي"
                  style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',boxSizing:'border-box'}}/>
              </div>
              <div>
                <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>تاريخ الانتهاء (فارغ = دائم)</label>
                <input type="date" value={licForm.expires_at} onChange={e=>setLicForm({...licForm,expires_at:e.target.value})}
                  style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',boxSizing:'border-box'}}/>
              </div>
              <div>
                <label style={{display:'block',fontSize:'12px',fontWeight:'bold',marginBottom:'4px'}}>ملاحظات</label>
                <input value={licForm.notes} onChange={e=>setLicForm({...licForm,notes:e.target.value})}
                  placeholder="اختياري"
                  style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',boxSizing:'border-box'}}/>
              </div>
            </div>
            {licMsg && <p style={{color:licMsg.startsWith('✅')?'#27ae60':'#e74c3c',fontSize:'13px',margin:'8px 0'}}>{licMsg}</p>}
            <button onClick={addLicense} style={{padding:'9px 20px',background:'#27ae60',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px',fontWeight:'bold'}}>
              ✅ إضافة الترخيص
            </button>
          </div>
          {licLoading ? <p style={{color:'#888'}}>جاري التحميل...</p> : (
            <table style={{width:'100%',borderCollapse:'collapse',fontSize:'13px'}}>
              <thead>
                <tr style={{background:'#1e3a5f',color:'white'}}>
                  <th style={{padding:'10px',textAlign:'right'}}>رقم الجهاز</th>
                  <th style={{padding:'10px',textAlign:'right'}}>الاسم</th>
                  <th style={{padding:'10px',textAlign:'center'}}>الحالة</th>
                  <th style={{padding:'10px',textAlign:'center'}}>الانتهاء</th>
                  <th style={{padding:'10px',textAlign:'center'}}>آخر تحقق</th>
                  <th style={{padding:'10px',textAlign:'center'}}>إجراء</th>
                </tr>
              </thead>
              <tbody>
                {licenses.length === 0 && <tr><td colSpan={6} style={{padding:'20px',textAlign:'center',color:'#888'}}>لا توجد تراخيص مسجلة</td></tr>}
                {licenses.map((lic,i) => (
                  <tr key={lic.id} style={{background:i%2===0?'#f8f9fa':'white',borderBottom:'1px solid #eee'}}>
                    <td style={{padding:'10px',fontFamily:'Courier New',fontSize:'12px'}}>{lic.device_id}</td>
                    <td style={{padding:'10px'}}>{lic.owner_name || '—'}</td>
                    <td style={{padding:'10px',textAlign:'center'}}>
                      <span style={{background:lic.is_active?'#d4edda':'#f8d7da',color:lic.is_active?'#155724':'#721c24',padding:'3px 10px',borderRadius:'12px',fontSize:'12px',fontWeight:'bold'}}>
                        {lic.is_active ? '✅ نشط' : '❌ ملغى'}
                      </span>
                    </td>
                    <td style={{padding:'10px',textAlign:'center',color:lic.expires_at?'#e67e22':'#27ae60'}}>{lic.expires_at || 'دائم'}</td>
                    <td style={{padding:'10px',textAlign:'center',color:'#888',fontSize:'12px'}}>
                      {lic.last_check_at ? new Date(lic.last_check_at).toLocaleDateString('ar-SA') : '—'}
                    </td>
                    <td style={{padding:'10px',textAlign:'center'}}>
                      <button onClick={()=>toggleLicense(lic.id, lic.is_active)}
                        style={{padding:'5px 10px',background:lic.is_active?'#e67e22':'#27ae60',color:'white',border:'none',borderRadius:'5px',cursor:'pointer',fontSize:'11px'}}>
                        {lic.is_active ? '⏸ إيقاف مؤقت' : '✅ تفعيل'}
                      </button>
                      <button onClick={async()=>{
                        if(!window.confirm('حذف هذا الترخيص نهائياً؟')) return;
                        try { await API.delete('/license/list/'+lic.id+'/'); fetchLicenses(); }
                        catch(e){ alert('خطأ في الحذف'); }
                      }} style={{padding:'5px 10px',background:'#e74c3c',color:'white',border:'none',borderRadius:'5px',cursor:'pointer',fontSize:'11px'}}>
                        🗑️ حذف
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}

export default ControlPanel;
